// @ts-ignore
import React, { useContext } from 'react';
import Hidden from '@mui/material/Hidden';
//styledContent
import { StyledNavBar, StyledNavBarMobile } from './hoa-side-drawer-styled-content';

import SideDrawerMenuContent from './hoa-side-drawer-menu-container';
import { GlobalContext  } from '../../context/hoa-global-context';
import './hoa-side-drawer.scss';

const sideDrawer = () => {

  const { open, toggleDrawer } = useContext<any>(GlobalContext)

  return (
    <>
      <Hidden lgDown>
        <StyledNavBar
        // @ts-ignore
          open={open}
          position={'left'}
          className="side-drawer-container"
        >
            <SideDrawerMenuContent />
        </StyledNavBar>
      </Hidden>

      <Hidden lgUp>
        <StyledNavBarMobile
          classes={{
            paper: 'side-drawer-container-mobile',
          }}
          anchor={'left'}
          variant="temporary"
          open={open}
          onClose={toggleDrawer}
          onOpen={() => { }}
          disableSwipeToOpen
          ModalProps={{
            keepMounted: true,
          }}
        >
          <SideDrawerMenuContent />
        </StyledNavBarMobile>
      </Hidden>
    </>
  )
}


export default sideDrawer;